import UserEventLog from "./user-event-log";
import {setMessage, setNotifications, upsertNotification} from "../../system/app-slice";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {normalizeMembershipEntity} from "../workspace-membership/workspace-membership-identity";
import {buildUnreadUserEventLogQuery} from "./user-event-log-queries";

const eventPopulate = {
    actor: {populate: {member: {populate: {profileImage: true}}}},
    workspace: {fields: ["name", "documentId"]},
    audit_log: {fields: ["documentId"]},
};

export default function useUserEventLog() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const {user} = useSelector(state => state.auth);
    const {workspaceMembershipData} = useSelector(state => state.app);
    const memberships = workspaceMembershipData?.workspace?.workspace_memberships || [];
    const dispatch = useDispatch();

    const run = async (action) => {
        setLoading(true);
        setError(null);
        try {
            return await action();
        } catch (requestError) {
            setError(requestError);
            throw requestError;
        } finally {
            setLoading(false);
        }
    };

    const getUserEventLogs = async () => {
        return run(async () => {
            const userEventLog = new UserEventLog();
            const response = await userEventLog.getAll(buildUnreadUserEventLogQuery(user?.id));
            const items = (response?.data || []).map((item) =>
                normalizeMembershipEntity(item, "userEventLog", memberships));

            items.filter((item) => !item.isRead && item.displayType === "toast")
                .forEach((item) => dispatch(setMessage({severity: "info", content: item.message})));
            dispatch(setNotifications(items));
            return items;
        }).catch(() => []);
    };

    const getUserEventLog = async (documentId) => run(async () => {
        try {
            const response = await new UserEventLog().getById(documentId, {populate: eventPopulate});
            return normalizeMembershipEntity(response?.data, "userEventLog", memberships) || null;
        } catch (requestError) {
            if ([403, 404].includes(requestError?.status)) return null;
            throw requestError;
        }
    });

    const updateUserEventLog = async (documentId, data) => run(async () => {
        const response = await new UserEventLog().updateItem(documentId, data, {populate: eventPopulate});
        const item = normalizeMembershipEntity(response?.data, "userEventLog", memberships);
        if (item) {
            dispatch(upsertNotification(item));
        }
        return item;
    });

    return {
        getUserEventLogs,
        getUserEventLog,
        updateUserEventLog,
        loading,
        error,
    };
}
